/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Image_Prefix_LabelInputs */

const en_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Prefix`)
};

const fr_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefixe d'image`)
};

const de_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildpräfix`)
};

const it_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefisso immagine`)
};

const ru_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Префикс изображения`)
};

const es_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefijo de imagen`)
};

const zh_cn2_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图像前缀`)
};

const ja_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像プレフィックス`)
};

const hi_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छवि उपसर्ग`)
};

const pt_pt2_image_export_image_prefix_label = /** @type {(inputs: Image_Export_Image_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefixo da imagem`)
};

/**
* | output |
* | --- |
* | "Image Prefix" |
*
* @param {Image_Export_Image_Prefix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_image_prefix_label = /** @type {((inputs?: Image_Export_Image_Prefix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Image_Prefix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_image_prefix_label(inputs)
	if (locale === "de") return de_image_export_image_prefix_label(inputs)
	if (locale === "it") return it_image_export_image_prefix_label(inputs)
	if (locale === "ru") return ru_image_export_image_prefix_label(inputs)
	if (locale === "es") return es_image_export_image_prefix_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_image_prefix_label(inputs)
	if (locale === "ja") return ja_image_export_image_prefix_label(inputs)
	if (locale === "hi") return hi_image_export_image_prefix_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_image_prefix_label(inputs)
	return en_image_export_image_prefix_label(inputs)
});